var _path, _path2, _path3, _path4, _path5, _path6, _line, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DatabaseRestore50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M28,11.06c-8.28,0-15,2.17-15,4.84c0,0,0,24.12,0,24.19c0,2.67,6.72,4.84,15,4.84s15-2.17,15-4.84 c0-0.07,0-24.19,0-24.19C43,13.23,36.28,11.06,28,11.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.8,6.51C23.2,6.5,23.6,6.5,24,6.5c8.56,0,15.5,2.24,15.5,5s-6.94,5-15.5,5s-15.5-2.24-15.5-5 c0-1.83,3.06-3.44,7.62-4.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M39.5,18.17c0-3.8,0-6.67,0-6.67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8.5,11.5c0,0,0,24.93,0,25c0,2.76,6.94,5,15.5,5c2.58,0,5.01-0.2,7.15-0.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M27.74,33.05c-1.2,0.1-2.45,0.15-3.74,0.15c-8.56,0-15.5-2.24-15.5-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.71,24.31c-2.03,0.31-4.3,0.49-6.71,0.49c-8.56,0-15.5-2.24-15.5-5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    x2: 39.5,
    y1: 45.69,
    y2: 24.8,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "33.31,31.3 39.5,24.8 45.69,31.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DatabaseRestore50);
export default __webpack_public_path__ + "static/media/icons8-database-restore-50.ebb7f0b7840f561f62c110afc1f9284f.svg";
export { ForwardRef as ReactComponent };